/* @ngInject */
const settingIcons = (

) => {
  const self = {}

  self.limit = 'swap_vert'

  return self
}
export default settingIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/setting/resources/icons.resource.js